<template>
  <div>
   
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
export default {
  name: 'home',
  components: {
   
  },
  data () {
    return {
      
    }
  },
  methods:{
     hasRole(roles) {
      return hasOneOf(this.$store.state.user.role, roles);
    },
  },
  mounted () {
    
  }
}
</script>
